import Block from "@/components/wrappers/block"
import classNames from "classnames"
import { useMediaPredicate } from "react-media-hook"

export default function FlowerfieldMunicipalities({ block }) {
  const headline = block.attrs?.headline ? block.attrs?.headline : false

  const podiumItems = [
    {
      place: 1,
      classes: "bg-green-100 text-green-25 text-6xl lg:text-8xl"
    },
    {
      place: 0,
      classes: "bg-summer-green-100 text-summer-green-25 text-6xl lg:text-8xl"
    },
    {
      place: 2,
      classes: "bg-dark-cyan-100 text-dark-cyan-25 text-6xl lg:text-8xl"
    }
  ]
  const municipalities = block.attrs?.municipalities ?? []

  const isMobile = useMediaPredicate("(max-width: 768px)")

  function Podium() {
    return (
      <>
        <div className="flex mb-10 lg:mb-20">
          {podiumItems.map((item) => (
            <div
              className="flex flex-1 flex-col justify-end text-center mx-2"
              key={item.place}>
              <h3>{municipalities[item.place].name}</h3>
              <div className="lg:text-2xl font-serif lg:mb-4">
                {(municipalities[item.place].meters / 1000).toLocaleString(
                  "sv-SE",
                  { minimumFractionDigits: 1, maximumFractionDigits: 1 }
                )}{" "}
                km
              </div>
              <div
                style={{
                  height:
                    municipalities[item.place].meters / (isMobile ? 200 : 100) +
                    "px"
                }}
                className={classNames(
                  "flex justify-center items-center font-bold rounded-xl font-serif",
                  item.classes
                )}>
                {item.place + 1}
              </div>
            </div>
          ))}
        </div>
      </>
    )
  }

  return (
    <Block block={block} className="mx-auto">
      <h2 className="mb-4 lg:mb-16 text-center">{headline}</h2>
      <Podium />
    </Block>
  )
}
